export default __webpack_public_path__ + "static/media/Chatz1.b12ab444.png";